<template>
  <div class="d-flex fd-column ai-center">
    <div class="CONFIRMATION">
      <vk-icon
          name="check-circle-outlined"
          size="72"
          class="c-green"
          selenium="submit-confirmation-tick-mark"/>
      <p
          class="text-bold m-t-3 h4 p-b-6 text-center m-x-1:mo"
          selenium="submit-confirmation-review-text">
        Thanks for sharing your experience!
        Your opinion makes a difference</p>
      <div>
        <router-link
            v-if="profiles.length > reviewedCount"
            button
            :to="to()"
            type="submit"
            class="btn btn-sm btn-lg:t"
            selenium="review-another-pro-button">Review Another Pro</router-link>
        <router-link
            v-else
            button
            :to="{name: 'consumer::dashboard'}"
            type="submit"
            class="btn btn-sm btn-lg:t"
            selenium="return-to-my-requests-button">Return to My Requests</router-link>
      </div>
    </div>
    <p class="text-center p-x-1 p-b-3">
      Visit
      <router-link
          to="/"
          class="link"
          selenium="review-page-footer-link">ProReferral.com</router-link>
      to discover how we can help with your next home project
    </p>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import reviewParams from '@/mixins/review-params';

export default {
  name: 'review-confirmation',
  mixins: [
    reviewParams,
  ],
  props: {
    order_hash: {
      type: String,
      required: true,
    },
    reviewedCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('propublicprofile', [
      'profiles',
    ]),
  },
  methods: {
    to () {
      const link = {
        name: 'consumer::reviews::new',
        query: {
          ...this.$route.query,
        },
      };
      delete link.query.profile_id;
      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .CONFIRMATION {
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 18*$unit 0;
  }
</style>
